import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const therapists = [{
  name: '小雅',
  role: 'Senior Therapist',
  exp: '5 Years Experience',
  rating: 4.9,
  specialty: 'Aromatherapy',
  image: 'https://cdn.magicpatterns.com/uploads/9F2weLuthibUh4uhwkAiM8/4ba86120c650434ca0993a617463c3f8.jpg'
}, {
  name: '美琳',
  role: 'Master Therapist',
  exp: '8 Years Experience',
  rating: 5.0,
  specialty: 'Thai Massage',
  image: 'https://cdn.magicpatterns.com/uploads/fqvqvS8EFuEagWa8sLggBk/da16b3dff67a49a6b18ea87ebc010f5c.jpg'
}, {
  name: '雪儿',
  role: 'Elite Companion',
  exp: '4 Years Experience',
  rating: 4.8,
  specialty: 'Social Events',
  image: 'https://cdn.magicpatterns.com/uploads/mvZ1w85CZ95vh4LLUNirji/a67add7451f04affa3d1c14fd475eb72.jpg'
}, {
  name: '心怡',
  role: 'Wellness Expert',
  exp: '6 Years Experience',
  rating: 4.9,
  specialty: 'Deep Tissue',
  image: 'https://cdn.magicpatterns.com/uploads/99Vhz4DRZjWbNTWSoHFhqp/17687258727114.jpg'
}];
export function TherapistProfiles() {
  return <section id="therapists" className="py-24 bg-white" data-id="element-186">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-187">
        <div className="text-center mb-16" data-id="element-188">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-189">
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-[#1a1a2e] mb-4" data-id="element-190">
              精英团队
            </h2>
            <p className="text-[#c9a96e] uppercase tracking-widest font-medium" data-id="element-191">
              Our Elite Professionals
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-192">
          {therapists.map((therapist, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group relative" data-id="element-193">
              <div className="aspect-[3/4] w-full overflow-hidden rounded-sm bg-gray-100 relative mb-4" data-id="element-194">
                {/* Profile Photo */}
                <img src={therapist.image} alt={therapist.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-195" />

                {/* Overlay Content */}
                <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-[#1a1a2e]/90 to-transparent pt-12" data-id="element-196">
                  <h3 className="text-2xl font-serif font-bold text-white mb-1" data-id="element-197">
                    {therapist.name}
                  </h3>
                  <p className="text-[#c9a96e] text-sm font-medium uppercase tracking-wider" data-id="element-198">
                    {therapist.role}
                  </p>
                </div>
              </div>

              <div className="bg-[#faf7f2] p-4 rounded-sm border border-gray-100 group-hover:border-[#c9a96e]/30 transition-colors" data-id="element-199">
                <div className="flex justify-between items-center mb-2" data-id="element-200">
                  <span className="text-sm text-gray-600 font-medium" data-id="element-201">
                    {therapist.specialty}
                  </span>
                  <div className="flex items-center text-[#c9a96e]" data-id="element-202">
                    <Star size={14} fill="currentColor" data-id="element-203" />
                    <span className="ml-1 text-sm font-bold" data-id="element-204">
                      {therapist.rating}
                    </span>
                  </div>
                </div>
                <p className="text-xs text-gray-400 uppercase tracking-wide" data-id="element-205">
                  {therapist.exp}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}